import React from "react";

const Tools = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M14.5 5.5L18.5 9.5M12 8L7 3L3 7L8 12M7 8L5.5 9.5M16 12L21 17L17 21L12 16M16 17L14.5 18.5M3 21H7L20 8C20.5304 7.46957 20.8284 6.75015 20.8284 6C20.8284 5.24985 20.5304 4.53043 20 4C19.4696 3.46957 18.7501 3.17157 18 3.17157C17.2499 3.17157 16.5304 3.46957 16 4L3 17V21Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

export default Tools;